<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row" v-if="userData.permissions['add_stock']==1">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-4">
                <div class="card" style="box-shadow: 0 0 2px gray;">
                  <div class="card-body">
                    <form @submit.prevent="AddtoCart">
                      <div class="form-group mb-2">
                        <label>Category</label>
                        <multiselect v-model="category" label="name" @input="FilterProducts" :options="productcategories"></multiselect>
                      </div>
                      <div class="form-group mb-2">
                        <label>Product</label>
                        <multiselect v-model="product" label="name" @input="FilterProductUnits" :options="products"></multiselect>
                      </div>
                      <div class="form-group mb-2">
                        <label>Unit</label>
                        <multiselect v-model="unit" label="unit" @input="FilterPrice" :options="units"></multiselect>
                      </div>
                      <div class="form-group mb-2">
                        <label>Buying Price</label>
                        <input v-model="price" type="number" required class="form-control" />
                      </div>
                      <div class="form-group mb-2">
                        <label>Quantity</label>
                        <input v-model="quantity" type="number" required min="1" class="form-control" />
                      </div>
                      <div class="form-group mb-2">
                        <label>Batch Number</label>
                        <input v-model="batch_number" type="text" required class="form-control" />
                      </div>
                      <div class="form-group mb-2">
                        <label>Expiry Date</label>
                        <input v-model="expiry_date" type="date" required class="form-control" />
                      </div>
                      <div v-if="expiryWarning" class="alert alert-warning py-2 px-2 mb-2">
                        {{ expiryWarning }}
                      </div>
                      <small class="text-muted d-block mb-2">Base Quantity: {{ unit ? unit.base_quantity : 0 }}</small>
                      <div class="form-group">
                        <b-button class="btn w-100" type="submit" variant="primary"><i class="fas fa-check-circle"></i> Add Batch</b-button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <div class="col-md-8">
                <div class="card" style="box-shadow: 0 0 2px gray;">
                  <span v-if="this.purchasecarts.length<=0">
                    <div class="d-flex justify-content-center p-5">
                      <span class="mdi mdi-pill text-success display-5"></span><br>
                      <span class="h4 mt-4">No Batch Selected</span>
                    </div>
                  </span>
                  <span v-else>
                    <div class="table-responsive">
                      <b-table :items="Items" :fields="Fields" responsive="sm" :busy="IsBusy">
                        <template #table-busy><div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow" small></b-spinner> <strong>No Data Found</strong></div></template>
                        <template #cell(index)="data">
                          {{ data.index + 1 }}
                        </template>
                        <template #cell(product)="data">
                          {{ data.item.product.name }}
                        </template>
                        <template #cell(category)="data">
                          {{ data.item.category.name }}
                        </template>
                        <template #cell(unit)="data">
                          {{ data.item.unit.unit_name }}
                        </template>
                        <template #cell(expiry_date)="data">
                          {{ data.item.expiry_date || "N/A" }}
                        </template>
                        <template #cell(actions)="data">
                          <b-button @click="remove(data.item.id,data.item.product.name)" type="button" class="btn-sm btn" variant="danger" v-b-modal.delete>
                            <i class="mdi mdi-trash-can"></i>
                          </b-button>
                        </template>
                      </b-table>
                    </div>
                    <div class="row mx-1">
                      <div class="col-md-4">
                        <div class="form-group">
                          <label>Total</label>
                          <input :value="cart_total" type="number" readonly class="form-control" />
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label>Amount Paid</label>
                          <input v-model="amountpaid" type="number" required class="form-control" />
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label>Supplier</label>
                          <multiselect v-model="supplier" label="name" :options="suppliers"></multiselect>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label>Payment Option</label>
                          <multiselect v-model="payoption" label="name" :options="paymentoptions"></multiselect>
                        </div>
                      </div>
                      <div class="col-md-4 mb-2">
                        <div class="form-group">
                          <label>Pay Date</label>
                          <input v-model="paydate" type="date" required class="form-control" />
                        </div>
                      </div>
                      <div class="col-md-4">
                        <b-button class="btn w-100 mt-4 mb-2" @click="SubmitExit" variant="primary" :disabled="submitSaving"><b-spinner v-if="submitSaving" small class="align-middle me-1"></b-spinner><i v-else class="mdi mdi-check-circle"></i> {{ submitSaving ? 'Submitting...' : 'SUBMIT & EXIT' }}</b-button>
                      </div>
                    </div>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br><br>
            <center><span class="text-primary h6">You have no permission to Add Stock</span></center>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="delete-unit" centered title="Delete Batch From Cart" title-class="font-18" hide-footer>
      <form @submit.prevent="removeFromCart">
        <input v-model="id" type="hidden">
        Are you sure you want to remove the Product Batch : <b>{{ productName }}</b> ?
        <div class="form-group d-flex justify-content-end">
          <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('delete-unit')">Close</b-button>
          <b-button type="submit" class="btn ms-1 w-30" variant="primary"><i class="fas fa-check-circle"></i> Submit</b-button>
        </div>
      </form>
    </b-modal>
  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import Multiselect from "vue-multiselect";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import {
  paymentoptionMethods, paymentoptionComputed,
  productcategoryMethods, productcategoryComputed,
  supplierMethods, supplierComputed,
  purchasecartMethods, purchasecartComputed
} from "@/state/helpers";

export default {
  page: {
    title: "Add Stock",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout, PageHeader, Multiselect
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "Add Stock",
      items: [{ text: "Dashboard", to: "/" }, { text: "Add Stock", active: true }],
      isBusy: true,
      fields: [
        { key: "index", label: "#", visible: true },
        { key: "category", label: "Category", visible: true },
        { key: "product", label: "Product Name", visible: true },
        { key: "unit", label: "Unit Name", visible: true },
        { key: "price", label: "Buying Price", visible: true },
        { key: "quantity", label: "Quantity", visible: true },
        { key: "batch_number", label: "Batch Number", visible: true },
        { key: "expiry_date", label: "Expiry Date", visible: true },
        { key: "actions", label: "Remove", visible: true },
      ],
      products: [],
      units: [],
      id: "",
      category: "",
      product: "",
      unit: "",
      price: "",
      quantity: "1",
      batch_number: "",
      expiry_date: "",
      paydate: new Date().toLocaleDateString("fr-CA"),
      payoption: "",
      amountpaid: "0",
      supplier: "",
      productName: "",
      submitSaving: false,
    };
  },
  computed: {
    ...purchasecartComputed,
    ...productcategoryComputed,
    ...paymentoptionComputed,
    ...supplierComputed,
    cart_total() {
      return this.purchasecarts.reduce((total, item) => total + Number(item.price || 0) * Number(item.quantity || 0), 0);
    },
    Fields() { return this.fields.filter(field => field.visible); },
    Items() { return this.purchasecarts.map((d) => ({ ...d })); },
    Cart() {
      return this.purchasecarts.map((d) => ({
        id: d.id,
        unit: d.unit.id,
        product: d.product.id,
        quantity: d.quantity,
        price: d.price,
        batch_number: d.batch_number,
        expiry_date: d.expiry_date,
      }));
    },
    IsBusy() { return this.purchasecarts.length === 0; },
    expiryWarning() {
      if (!this.expiry_date) {
        return "";
      }
      const days = this.daysUntilDate(this.expiry_date);
      if (days < 0) {
        return "This expiry date is already past. Please choose a valid live batch expiry date.";
      }
      if (days <= 10) {
        return `Warning: this batch will expire in ${days} day${days === 1 ? "" : "s"}.`;
      }
      return "";
    },
  },
  mounted() {
    this.fetchPaymentoptions();
    this.fetchPurchaseCart();
    this.fetchCategories();
    this.fetchSuppliers();
    this.isBusy = false;
  },
  methods: {
    ...purchasecartMethods,
    ...productcategoryMethods,
    ...paymentoptionMethods,
    ...supplierMethods,
    remove(id, productName) {
      this.id = id;
      this.productName = productName;
      this.$bvModal.show("delete-unit");
    },
    async FilterProducts() {
      const response = await axios.get(`/productbycategory/${this.category.id}`);
      this.products = response.data.products;
    },
    async FilterProductUnits() {
      const response = await axios.get(`/unitsbyproduct/${this.product.id}`);
      this.units = response.data.units;
      this.unit = "";
      this.price = "";
    },
    async FilterPrice() {
      if (!this.unit || !this.product) return;
      const response = await axios.get(`/productbuyingprice/${this.unit.unit_id},${this.product.id}`);
      this.price = response.data.price;
    },
    daysUntilDate(dateValue) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const target = new Date(dateValue);
      target.setHours(0, 0, 0, 0);
      return Math.ceil((target - today) / (1000 * 60 * 60 * 24));
    },
    formatHumanDate(dateValue) {
      if (!dateValue) return "";
      const date = new Date(dateValue);
      if (Number.isNaN(date.getTime())) {
        return dateValue;
      }
      return date.toLocaleDateString("en-GB", {
        day: "numeric",
        month: "long",
        year: "numeric",
      });
    },
    resetEntryForm() {
      this.category = "";
      this.product = "";
      this.unit = "";
      this.price = "";
      this.quantity = "1";
      this.batch_number = "";
      this.expiry_date = "";
    },
    buildExpiryNotificationPayload(days) {
      return {
        title: "Expiring stock warning",
        productName: this.product?.name || null,
        batchNumber: this.batch_number || null,
        details: [
          this.product?.name ? `Product: ${this.product.name}` : null,
          this.batch_number ? `Batch: ${this.batch_number}` : null,
          this.expiry_date ? `Expiry date: ${this.formatHumanDate(this.expiry_date)}` : null,
          days !== null && days !== undefined ? `Expires in ${days} day${days === 1 ? "" : "s"}` : null,
        ],
      };
    },
    readableError(error, fallback = "Something went wrong. Please try again.") {
      const validationErrors = error?.response?.data?.errors;
      if (validationErrors) {
        const firstKey = Object.keys(validationErrors)[0];
        if (firstKey && validationErrors[firstKey]?.length) {
          return validationErrors[firstKey][0];
        }
      }
      return error?.response?.data?.message || fallback;
    },
    async AddtoCart() {
      const expiryDays = this.daysUntilDate(this.expiry_date);
      if (expiryDays < 0) {
        this.$toast.error("Expired batches cannot be added to stock.");
        return;
      }
      if (expiryDays <= 10) {
        this.$toast.warning(this.expiryWarning, {
          notificationCenter: this.buildExpiryNotificationPayload(expiryDays),
        });
      }
      const formData = new FormData();
      formData.append("category", this.category.id);
      formData.append("product", this.product.id);
      formData.append("unit", this.unit.unit_id);
      formData.append("price", this.price);
      formData.append("quantity", this.quantity);
      formData.append("batch_number", this.batch_number);
      formData.append("expiry_date", this.expiry_date);
      try {
        await axios.post("/addpurchasecart", formData);
        this.payoption = this.paymentoptions.find(option => option.set_default == 1) || this.payoption;
        this.fetchPurchaseCart();
        this.resetEntryForm();
      } catch (error) {
        this.$toast.error(this.readableError(error, "The stock batch could not be added. Please check the details and try again."));
      }
    },
    async removeFromCart() {
      const formData = new FormData();
      formData.append("id", this.id);
      await axios.post("/deletepurchasecart", formData);
      this.fetchPurchaseCart();
      this.$bvModal.hide("delete-unit");
    },
    async SubmitExit() {
      if (!this.purchasecarts.length) {
        this.$toast.error("Add at least one stock batch before submitting.");
        return;
      }
      if (!this.payoption || !this.payoption.id) {
        this.$toast.error("Select a payment option before submitting stock.");
        return;
      }
      if (!this.paydate) {
        this.$toast.error("Select the payment date before submitting stock.");
        return;
      }
      const obj = {
        cart: this.Cart,
        amount: this.amountpaid,
        total: this.cart_total,
        supplier: this.supplier?.id || null,
        payoption: this.payoption?.id || null,
        paydate: this.paydate
      };
      this.submitSaving = true;
      try {
        await axios.post("/savepurchasecart", obj);
        this.fetchPurchaseCart();
        this.amountpaid = "0";
        this.payoption = this.paymentoptions.find(option => option.set_default == 1) || "";
        this.supplier = "";
        this.$toast.success("Stock received successfully.");
      } catch (error) {
        this.$toast.error(this.readableError(error, "The stock submission could not be completed. Please review the form and try again."));
      } finally {
        this.submitSaving = false;
      }
    },
  },
};
</script>
